import options from './things-toolbox.component';

export default {
    selector: 'dtThingsToolbox',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/things-toolbox/index.js